/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_2_HeadingInputs */

const en_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facility & Industry`)
};

const es_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalaciones y sector`)
};

const de_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlage und Branche`)
};

const zh_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设施与行业`)
};

const ar_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنشأة وقطاع الغولف`)
};

const fr_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installations et filière golf`)
};

const vi_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ sở và ngành`)
};

const sw_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kituo na Sekta ya Gofu`)
};

const th_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามฝึกและวงการกอล์ฟ`)
};

const bs_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekat i golf branša`)
};

const ja_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`施設・業界`)
};

const ko_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시설 및 업계`)
};

const pt_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalações e setor`)
};

const it_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Struttura e settore`)
};

const sv_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anläggning och bransch`)
};

const nl_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faciliteit & golfbranche`)
};

const da_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlæg og branche`)
};

const nb_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlegg og bransje`)
};

const fi_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoituskeskus ja golfala`)
};

const pl_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiekt i branża golfowa`)
};

const ru_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Комплекс и отрасль`)
};

const tr_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tesis ve Sektör`)
};

const hi_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुविधा और गोल्फ़ उद्योग`)
};

const id_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasilitas & Industri Golf`)
};

const ms_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemudahan & Industri Golf`)
};

const cs_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Areál a golfový obor`)
};

const el_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εγκατάσταση & κλάδος του γκολφ`)
};

const he_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המתקן וענף הגולף`)
};

const af_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasiliteit en bedryf`)
};

const hu_about_content_honor_2_heading = /** @type {(inputs: About_Content_Honor_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létesítmény és golfszakma`)
};

/**
* | output |
* | --- |
* | "Facility & Industry" |
*
* @param {About_Content_Honor_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_2_heading = /** @type {((inputs?: About_Content_Honor_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_2_heading(inputs)
	if (locale === "de") return de_about_content_honor_2_heading(inputs)
	if (locale === "zh") return zh_about_content_honor_2_heading(inputs)
	if (locale === "ar") return ar_about_content_honor_2_heading(inputs)
	if (locale === "fr") return fr_about_content_honor_2_heading(inputs)
	if (locale === "vi") return vi_about_content_honor_2_heading(inputs)
	if (locale === "sw") return sw_about_content_honor_2_heading(inputs)
	if (locale === "th") return th_about_content_honor_2_heading(inputs)
	if (locale === "bs") return bs_about_content_honor_2_heading(inputs)
	if (locale === "ja") return ja_about_content_honor_2_heading(inputs)
	if (locale === "ko") return ko_about_content_honor_2_heading(inputs)
	if (locale === "pt") return pt_about_content_honor_2_heading(inputs)
	if (locale === "it") return it_about_content_honor_2_heading(inputs)
	if (locale === "sv") return sv_about_content_honor_2_heading(inputs)
	if (locale === "nl") return nl_about_content_honor_2_heading(inputs)
	if (locale === "da") return da_about_content_honor_2_heading(inputs)
	if (locale === "nb") return nb_about_content_honor_2_heading(inputs)
	if (locale === "fi") return fi_about_content_honor_2_heading(inputs)
	if (locale === "pl") return pl_about_content_honor_2_heading(inputs)
	if (locale === "ru") return ru_about_content_honor_2_heading(inputs)
	if (locale === "tr") return tr_about_content_honor_2_heading(inputs)
	if (locale === "hi") return hi_about_content_honor_2_heading(inputs)
	if (locale === "id") return id_about_content_honor_2_heading(inputs)
	if (locale === "ms") return ms_about_content_honor_2_heading(inputs)
	if (locale === "cs") return cs_about_content_honor_2_heading(inputs)
	if (locale === "el") return el_about_content_honor_2_heading(inputs)
	if (locale === "he") return he_about_content_honor_2_heading(inputs)
	if (locale === "af") return af_about_content_honor_2_heading(inputs)
	if (locale === "hu") return hu_about_content_honor_2_heading(inputs)
	return en_about_content_honor_2_heading(inputs)
});